const getCustomerSuccessAlertChickletHoverAction = __args => {
  return {
    PrimaryAction: undefined,
    SecondaryActions: []
  };
};
export default getCustomerSuccessAlertChickletHoverAction;